import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  loadingDialog = null;

  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController,
    private log: NGXLogger
  ) {}

  public async showLoading(msg) {
    //hide if other dialog is already shown
    await this.hideLoading();
    this.loadingDialog = await this.loadingController.create({ message: msg });
    this.log.debug(`Show Loading: '${msg}'`);
    return this.loadingDialog.present();
  }
  public async hideLoading() {
    if (this.loadingDialog) {
      await this.loadingDialog.dismiss();
      this.log.debug(`Hide Loading`);
      this.loadingDialog = null;
    }
  }
  public async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
    });
    return toast.present();
  }
}
